import { Box, InputBase, MenuItem, Select } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

import { fieldInputSx } from '@/apps/latest/shared/styles/inlineInput'

const SEXES = ['男', '女']

interface Props {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

// お客様の性別。様式は印字の「男・女」の片方を丸で囲む 2 値の欄で、出力も 男 か 女 のときだけ丸を移す
// (打たせると「女性」で黙って丸が付かない) ので、選ばせる。以前に打った値 (「女性」など) はそのまま
// 1 行足して見せる。design-book 04-apps/kakeru.md「管理栄養士の記録」。
export const SexSelect = ({ value, onChange, disabled }: Props) => (
  <Select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    displayEmpty
    input={<InputBase sx={fieldInputSx} />}
    SelectDisplayProps={{ 'aria-label': '性別' }}
    renderValue={(selected) =>
      selected || (
        <Box component="span" sx={{ color: colorTokens.fg.muted }}>
          男 / 女
        </Box>
      )
    }
  >
    {[...SEXES, ...(value && !SEXES.includes(value) ? [value] : [])].map(
      (sex) => (
        <MenuItem key={sex} value={sex}>
          {sex}
        </MenuItem>
      )
    )}
  </Select>
)
